import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles, createStyles, Theme, Button } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import { Views } from "../../helpers/constants";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      display: "flex",
      color: theme.palette.paused.main,
      "&:hover": {
        background: "transparent",
      },
    },
    activeButton: {
      backgroundColor: theme.palette.lightTransparent.main,
      "&:hover": {
        backgroundColor: theme.palette.lightTransparent.main,
      },
    },
    buttonContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: theme.spacing(1.5), // Adjust the gap between elements
    },
  })
);

export default function SubscriptionManagementOptions() {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  /* ---- Utils ---- */
  const handleToSubscriptions = () => {
    history.push(Views.SUBSCRIPTION);
  };
  const handleToBillingManagers = () => {
    history.push(Views.BILLING_MANAGERS);
  };

  return (
    <div className={classes.buttonContainer}>
      <Button
        onClick={handleToSubscriptions}
        className={`${classes.button} ${
          location.pathname === Views.SUBSCRIPTION ? classes.activeButton : ""
        }`}
      >
        {t("subscription_plans")}
      </Button>
      <Button
        onClick={handleToBillingManagers}
        className={`${classes.button} ${
          location.pathname === Views.BILLING_MANAGERS
            ? classes.activeButton
            : ""
        }`}
      >
        {t("billing_managers")}
      </Button>
    </div>
  );
}
